/* eslint-disable */
import { AfterViewInit, Component } from '@angular/core';
import { Transition } from '@uirouter/angular';
import { TranslateService } from '@ngx-translate/core';
import { DocumentLanguageItem, DocumentTextReadModel } from '../../../../util/document/document-utils';
import { Arrays } from '../../../../lib/util/arrays';
import { DocumentTextService } from '../../../../lib/document/document-text.service';
import { DocumentLanguageService } from '../../../../lib/document/document-language.service';
import { DocumentLanguageUtil } from '../../../../util/document/document-language-utils';
import { DocumentGroup } from '../../../../lib/document/document-group.service';
import { DocumentGroupService } from '../../../../lib/document/document-group.service';
import { ResourceQueryResult } from '../../../../lib/util/services';
import { StringKey } from '../../../../app.string-keys';
/* eslint-enable */

@Component({
  selector: 'app-document-text-read',
  templateUrl: 'document-text-read.component.html',
  styleUrls: ['document-text-read.component.scss']
})
export class DocumentTextReadComponent implements AfterViewInit {

  model: DocumentTextReadModel;
  documentId: number;
  documentGroupList: DocumentGroup[] = [];
  documentLanguageList: DocumentLanguageItem[] = [];

  constructor(
    private translateService: TranslateService,
    private documentLanguageService: DocumentLanguageService,
    private documentLanguageUtil: DocumentLanguageUtil,
    private documentGroupService: DocumentGroupService,
    private documentTextService: DocumentTextService,
    private transition: Transition) {
    this.documentId = this.transition.params().id;
    this.model = new DocumentTextReadModel();
  }

  ngAfterViewInit() {
    this.loadDocumentGroups(() => {
      this.loadLanguageCodes();
      this.loadModel();
    });
  }

  loadModel() {
    this.documentTextService.get({
      id: this.documentId
    }).subscribe( documentText => {
      const readModel = new DocumentTextReadModel();
      readModel.id = documentText.id;
      readModel.name = documentText.name;
      readModel.code = documentText.code;
      readModel.value = documentText.value;
      readModel.comment = documentText.comment;
      readModel.creation_time = documentText.creation_time;
      readModel.update_time = documentText.update_time;
      readModel.disabled = documentText.disabled;
      readModel.document_group = {
        id: documentText.document_group_id,
        text: this.getDocumentGroupName(documentText.document_group_id)
      };
      this.loadLanguageCodes(documentText.language_code);
      this.model = readModel;
    });
  }

  private loadLanguageCodes(language_code?: string) {
    this.documentLanguageService.query().subscribe( (result: string[]) => {
      const def = this.createDefaultLanguageCode();
      this.model.language_code = def;
      this.documentLanguageList.push(def);

      Arrays.iterateByIndex( result, language => {
        const languageItem = new DocumentLanguageItem();
        languageItem.id = language;
        languageItem.text = this.documentLanguageUtil.getDocumentLanguageName(language);

        if (languageItem.id === language_code) {
          this.model.language_code = languageItem;
        }
        this.documentLanguageList.push(languageItem);
      });
    });
  }

  private createDefaultLanguageCode(): DocumentLanguageItem {
    const def = new DocumentLanguageItem();
    def.id = null;
    def.text = '';
    this.translateService.get(StringKey.COMMON_VALUE_UNSELECTED).subscribe(
      (text: string) => {
        def.text = text;
      }
    );
    return def;
  }

  loadDocumentGroups(completion: () => void) {
    this.documentGroupService.query({}).subscribe((result: ResourceQueryResult<DocumentGroup>) => {

        result.items.forEach( group => {
          this.documentGroupList.push(group);
        });
        completion();

      }, (error: any) => {
        completion();
      });
  }

  getDocumentGroupName(documentGroupId?: number): string {
    if (!documentGroupId) {
      return '';
    }

    let groupName = '';
    Arrays.iterateByIndex(this.documentGroupList, group => {
        if (group.id === documentGroupId) {
          groupName = group.name;
        }
    });
    return groupName;
  }

  back() {
    window.history.back();
  }

}
